// Helper functions previously in mock data files

export const calculateGrade = (total) => {
  if (total >= 70) return 'A';
  if (total >= 60) return 'B';
  if (total >= 50) return 'C';
  if (total >= 45) return 'D';
  if (total >= 40) return 'E';
  return 'F';
};

export const getGradeColor = (grade) => {
  switch (grade) {
    case 'A': return 'text-emerald-600 bg-emerald-50';
    case 'B': return 'text-blue-600 bg-blue-50';
    case 'C': return 'text-amber-600 bg-amber-50';
    case 'D': return 'text-orange-600 bg-orange-50';
    case 'E': return 'text-red-600 bg-red-50';
    case 'F': return 'text-red-700 bg-red-100';
    default: return 'text-slate-600 bg-slate-50';
  }
};

export const getStatusColor = (status) => {
  switch (status) {
    case 'Active':
    case 'Paid':
    case 'Approved':
      return 'text-emerald-600 bg-emerald-50';
    case 'Inactive':
      return 'text-slate-600 bg-slate-100';
    case 'Suspended':
    case 'Rejected':
      return 'text-red-600 bg-red-50';
    case 'Pending':
      return 'text-amber-600 bg-amber-50';
    default:
      return 'text-slate-600 bg-slate-50';
  }
};

export const getNotificationIcon = (type) => {
  switch (type) {
    case 'deadline': return 'fa-clock text-red-500 bg-red-50';
    case 'student': return 'fa-user-plus text-blue-500 bg-blue-50';
    case 'attendance': return 'fa-clipboard-check text-amber-500 bg-amber-50';
    case 'payment': return 'fa-credit-card text-emerald-500 bg-emerald-50';
    case 'event': return 'fa-calendar text-purple-500 bg-purple-50';
    case 'info': return 'fa-info-circle text-indigo-500 bg-indigo-50';
    default: return 'fa-bell text-slate-500 bg-slate-50';
  }
};

